import { render, staticRenderFns } from "./EventReminder3.vue?vue&type=template&id=254be6b0&"
import script from "./EventReminder3.vue?vue&type=script&lang=js&"
export * from "./EventReminder3.vue?vue&type=script&lang=js&"
import style0 from "./EventReminder3.vue?vue&type=style&index=0&id=254be6b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports